import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_displayColor1gavqb36ugd6h as get_displayColor,
  DirectlyDisplayableStatebtdfi3611j0b as DirectlyDisplayableState,
} from '../../work/payApps/data.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  Manual3lg0s0ycvhhh4 as Manual,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ChangeRequestItemWrapperlr7b47p0t9ty as ChangeRequestItemWrapper } from '../../work/changeOrders/data.mjs';
import {
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  Accept733y3zepx42g as Accept,
  RequestComplete2fbpvksxlxjbf as RequestComplete,
} from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var Type_LineItem_instance;
var Type_Incident_instance;
var Type_Draw_instance;
var Type_Change_instance;
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_LineItem_instance = Type().igo('LineItem', 0, 'Line Item');
  Type_Incident_instance = Type().igo('Incident', 1, 'Incident');
  Type_Draw_instance = Type().igo('Draw', 2, 'Draw');
  Type_Change_instance = Type().igo('Change', 3, 'Change');
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.jgo_1 = function_0;
      }
      wi(a, b) {
        return this.jgo_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.jgo_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function ConcernCardInfo$Companion$comparator$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.ngo_1.g90();
  var tmp$ret$1 = b.ngo_1.g90();
  return compareValues(tmp, tmp$ret$1);
}
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ extends Enum() {
      static igo(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.hgo_1 = displayName;
        return $this;
      }
    }
    initMetadataForClass($, 'Type');
    TypeClass = $;
  }
  return TypeClass;
}
var ManualStateClass;
function ManualState() {
  if (ManualStateClass === VOID) {
    class $ {
      constructor(displayName, color, priority) {
        priority = priority === VOID ? 0 : priority;
        this.xgo_1 = displayName;
        this.ygo_1 = color;
        this.zgo_1 = priority;
      }
      e90() {
        return this.xgo_1;
      }
      hg0() {
        return this.ygo_1;
      }
      g90() {
        return this.zgo_1;
      }
      toString() {
        return 'ManualState(displayName=' + this.xgo_1 + ', color=' + this.ygo_1.toString() + ', priority=' + this.zgo_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.xgo_1);
        result = imul(result, 31) + this.ygo_1.hashCode() | 0;
        result = imul(result, 31) + this.zgo_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ManualState()))
          return false;
        if (!(this.xgo_1 === other.xgo_1))
          return false;
        if (!this.ygo_1.equals(other.ygo_1))
          return false;
        if (!(this.zgo_1 === other.zgo_1))
          return false;
        return true;
      }
    }
    protoOf($).f90 = get_displayColor;
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'ManualState', VOID, VOID, [DirectlyDisplayableState()]);
    ManualStateClass = $;
  }
  return ManualStateClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_0 = ConcernCardInfo$Companion$comparator$lambda;
        // Inline function 'kotlin.comparisons.thenBy' call
        var this_0 = new (sam$kotlin_Comparator$0())(tmp_0);
        var tmp_1 = (a, b) => {
          var previousCompare = this_0.compare(a, b);
          var tmp;
          if (!(previousCompare === 0)) {
            tmp = previousCompare;
          } else {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp_0 = a.ogo_1;
            var tmp$ret$2 = b.ogo_1;
            tmp = compareValues(tmp_0, tmp$ret$2);
          }
          return tmp;
        };
        tmp.agp_1 = new (sam$kotlin_Comparator$0())(tmp_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function Type_LineItem_getInstance() {
  Type_initEntries();
  return Type_LineItem_instance;
}
function Type_Incident_getInstance() {
  Type_initEntries();
  return Type_Incident_instance;
}
function Type_Draw_getInstance() {
  Type_initEntries();
  return Type_Draw_instance;
}
function Type_Change_getInstance() {
  Type_initEntries();
  return Type_Change_instance;
}
var ConcernCardInfoClass;
function ConcernCardInfo() {
  if (ConcernCardInfoClass === VOID) {
    class $ {
      static bgp(type, id, title, state, timestamp, mostRecentMessage, messageName, readBy, actionIcon, timerState, escalationLevel, tags, dialog) {
        Companion_getInstance_0();
        readBy = readBy === VOID ? emptySet() : readBy;
        actionIcon = actionIcon === VOID ? null : actionIcon;
        timerState = timerState === VOID ? null : timerState;
        escalationLevel = escalationLevel === VOID ? null : escalationLevel;
        tags = tags === VOID ? emptySet() : tags;
        dialog = dialog === VOID ? null : dialog;
        var $this = createThis(this);
        $this.kgo_1 = type;
        $this.lgo_1 = id;
        $this.mgo_1 = title;
        $this.ngo_1 = state;
        $this.ogo_1 = timestamp;
        $this.pgo_1 = mostRecentMessage;
        $this.qgo_1 = messageName;
        $this.rgo_1 = readBy;
        $this.sgo_1 = actionIcon;
        $this.tgo_1 = timerState;
        $this.ugo_1 = escalationLevel;
        $this.vgo_1 = tags;
        $this.wgo_1 = dialog;
        return $this;
      }
      cgp(other) {
        return Companion_getInstance_0().agp_1.compare(this, other);
      }
      d(other) {
        return this.cgp(other instanceof ConcernCardInfo() ? other : THROW_CCE());
      }
      static dgp(type, id, title, state, timestamp, mostRecentMessage, readBy, actionIcon, timerState, escalationLevel, tags, dialog) {
        Companion_getInstance_0();
        readBy = readBy === VOID ? emptySet() : readBy;
        actionIcon = actionIcon === VOID ? null : actionIcon;
        timerState = timerState === VOID ? null : timerState;
        escalationLevel = escalationLevel === VOID ? null : escalationLevel;
        tags = tags === VOID ? emptySet() : tags;
        dialog = dialog === VOID ? null : dialog;
        return this.bgp(type, id, title, state, timestamp, mostRecentMessage, mostRecentMessage.h94().e90(), readBy, actionIcon, timerState, escalationLevel, tags, dialog);
      }
      static egp(draw, lineItem, payApp, multiple, dialog) {
        Companion_getInstance_0();
        multiple = multiple === VOID ? false : multiple;
        var tmp3_type = Type_Draw_getInstance();
        var tmp4_id = draw.o6v_1;
        var tmp5_title = 'Draw ' + payApp.i6y_1;
        var tmp6_state = new (ManualState())('Waited', AppColors_getInstance().jfz_1.zg9_1);
        var tmp0_elvis_lhs = draw.p96();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp7_timestamp = tmp;
        var tmp8_mostRecentMessage = MessageData().lgp(draw, lineItem, payApp.i6y_1, multiple);
        var tmp1_safe_receiver = draw.t6v_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r53_1;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var tmp9_readBy = tmp_0;
        return this.dgp(tmp3_type, tmp4_id, tmp5_title, tmp6_state, tmp7_timestamp, tmp8_mostRecentMessage, tmp9_readBy, VOID, VOID, VOID, VOID, dialog);
      }
      static mgp(item, multiple, dialog) {
        Companion_getInstance_0();
        multiple = multiple === VOID ? false : multiple;
        var tmp6_type = Type_Change_getInstance();
        var tmp7_id = item.f40();
        var tmp8_title = 'Change ' + substringBefore(item.y94(), _Char___init__impl__6a9atx(46));
        var tmp9_state = new (ManualState())('Rejected', AppColors_getInstance().jfz_1.zg9_1);
        var tmp0_safe_receiver = denied(item);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d95();
        var tmp;
        if (tmp1_elvis_lhs == null) {
          var tmp2_safe_receiver = accepted(item);
          tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.o54_1;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp;
        var tmp_0;
        if (tmp3_elvis_lhs == null) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance).b1m();
        } else {
          tmp_0 = tmp3_elvis_lhs;
        }
        var tmp10_timestamp = tmp_0;
        var tmp11_mostRecentMessage = MessageData().ngp(item, multiple);
        var tmp4_safe_receiver = denied(item);
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.r53_1;
        var tmp_1;
        if (tmp5_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = tmp5_elvis_lhs;
        }
        var tmp12_readBy = tmp_1;
        return this.dgp(tmp6_type, tmp7_id, tmp8_title, tmp9_state, tmp10_timestamp, tmp11_mostRecentMessage, tmp12_readBy, VOID, VOID, VOID, VOID, dialog);
      }
      toString() {
        return 'ConcernCardInfo(type=' + this.kgo_1.toString() + ', id=' + this.lgo_1.toString() + ', title=' + this.mgo_1 + ', state=' + toString(this.ngo_1) + ', timestamp=' + this.ogo_1.toString() + ', mostRecentMessage=' + toString(this.pgo_1) + ', messageName=' + this.qgo_1 + ', readBy=' + toString(this.rgo_1) + ', actionIcon=' + toString_0(this.sgo_1) + ', timerState=' + toString_0(this.tgo_1) + ', escalationLevel=' + toString_0(this.ugo_1) + ', tags=' + toString(this.vgo_1) + ', dialog=' + toString_0(this.wgo_1) + ')';
      }
      hashCode() {
        var result = this.kgo_1.hashCode();
        result = imul(result, 31) + this.lgo_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.mgo_1) | 0;
        result = imul(result, 31) + hashCode(this.ngo_1) | 0;
        result = imul(result, 31) + this.ogo_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.pgo_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.qgo_1) | 0;
        result = imul(result, 31) + hashCode(this.rgo_1) | 0;
        result = imul(result, 31) + (this.sgo_1 == null ? 0 : this.sgo_1.hashCode()) | 0;
        result = imul(result, 31) + (this.tgo_1 == null ? 0 : this.tgo_1.hashCode()) | 0;
        result = imul(result, 31) + (this.ugo_1 == null ? 0 : this.ugo_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.vgo_1) | 0;
        result = imul(result, 31) + (this.wgo_1 == null ? 0 : hashCode(this.wgo_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ConcernCardInfo()))
          return false;
        if (!this.kgo_1.equals(other.kgo_1))
          return false;
        if (!this.lgo_1.equals(other.lgo_1))
          return false;
        if (!(this.mgo_1 === other.mgo_1))
          return false;
        if (!equals(this.ngo_1, other.ngo_1))
          return false;
        if (!this.ogo_1.equals(other.ogo_1))
          return false;
        if (!equals(this.pgo_1, other.pgo_1))
          return false;
        if (!(this.qgo_1 === other.qgo_1))
          return false;
        if (!equals(this.rgo_1, other.rgo_1))
          return false;
        if (!equals(this.sgo_1, other.sgo_1))
          return false;
        if (!equals(this.tgo_1, other.tgo_1))
          return false;
        if (!equals(this.ugo_1, other.ugo_1))
          return false;
        if (!equals(this.vgo_1, other.vgo_1))
          return false;
        if (!equals(this.wgo_1, other.wgo_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ConcernCardInfo', VOID, VOID, [Comparable()]);
    ConcernCardInfoClass = $;
  }
  return ConcernCardInfoClass;
}
function denied(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof PendingItemChange()) {
    tmp = _this__u8e3s4.j72_1;
  } else {
    if (_this__u8e3s4 instanceof PendingLineItem()) {
      tmp = _this__u8e3s4.c76_1;
    } else {
      if (_this__u8e3s4 instanceof ChangeRequestItemWrapper()) {
        tmp = denied(_this__u8e3s4.ogp_1);
      } else {
        throw IllegalArgumentException().a1('Unsupported ChangeRequestItem');
      }
    }
  }
  return tmp;
}
function accepted(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof PendingItemChange()) {
    tmp = _this__u8e3s4.h72_1;
  } else {
    if (_this__u8e3s4 instanceof PendingLineItem()) {
      tmp = _this__u8e3s4.b76_1;
    } else {
      if (_this__u8e3s4 instanceof ChangeRequestItemWrapper()) {
        tmp = accepted(_this__u8e3s4.ogp_1);
      } else {
        throw IllegalArgumentException().a1('Unsupported ChangeRequestItem');
      }
    }
  }
  return tmp;
}
var MessageDataClass;
function MessageData() {
  if (MessageDataClass === VOID) {
    class $ {
      static rgp(message, clientMessage, created, sender, type, readBy) {
        readBy = readBy === VOID ? emptySet() : readBy;
        var $this = createThis(this);
        $this.fgp_1 = message;
        $this.ggp_1 = clientMessage;
        $this.hgp_1 = created;
        $this.igp_1 = sender;
        $this.jgp_1 = type;
        $this.kgp_1 = readBy;
        return $this;
      }
      j() {
        return this.fgp_1;
      }
      i94() {
        return this.ggp_1;
      }
      k94() {
        return this.hgp_1;
      }
      j94() {
        return this.igp_1;
      }
      h94() {
        return this.jgp_1;
      }
      v91() {
        return this.kgp_1;
      }
      static lgp(draw, lineItem, number, multiple) {
        multiple = multiple === VOID ? false : multiple;
        var tmp0_safe_receiver = draw.t6v_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q53_1;
        var tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = draw.p96();
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance).b1m();
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var tmp_1 = tmp_0;
        var tmp3_safe_receiver = draw.t6v_1;
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.p53_1;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.k54_1;
        var tmp_2;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = draw.s6v_1;
          tmp_2 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.k54_1;
        } else {
          tmp_2 = tmp5_elvis_lhs;
        }
        var tmp7_elvis_lhs = tmp_2;
        var tmp_3 = tmp7_elvis_lhs == null ? Companion_getInstance().k2p() : tmp7_elvis_lhs;
        var tmp_4 = new (Manual())(lineItem.i20() + ', ' + MonetaryValue__toString_impl_xslc77(draw.r6v_1) + (multiple ? ' (Multiple Waits)' : ''));
        var tmp8_safe_receiver = draw.t6v_1;
        var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.r53_1;
        var tmp_5;
        if (tmp9_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_5 = emptySet();
        } else {
          tmp_5 = tmp9_elvis_lhs;
        }
        return this.rgp(tmp, true, tmp_1, tmp_3, tmp_4, tmp_5);
      }
      static ngp(item, multiple) {
        multiple = multiple === VOID ? false : multiple;
        var tmp0_safe_receiver = denied(item);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q53_1;
        var tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        var tmp2_safe_receiver = denied(item);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d95();
        var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? item.z94() : tmp3_elvis_lhs;
        var tmp_0;
        if (tmp4_elvis_lhs == null) {
          // Inline function 'com.lightningkite.now' call
          tmp_0 = get_default(Companion_instance).b1m();
        } else {
          tmp_0 = tmp4_elvis_lhs;
        }
        var tmp_1 = tmp_0;
        var tmp5_safe_receiver = denied(item);
        var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.p53_1;
        var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.k54_1;
        var tmp_2;
        if (tmp7_elvis_lhs == null) {
          var tmp8_safe_receiver = accepted(item);
          tmp_2 = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.k54_1;
        } else {
          tmp_2 = tmp7_elvis_lhs;
        }
        var tmp9_elvis_lhs = tmp_2;
        var tmp_3 = tmp9_elvis_lhs == null ? Companion_getInstance().k2p() : tmp9_elvis_lhs;
        var tmp_4 = new (Manual())('Change ' + item.y94() + (multiple ? ' (Multiple Rejections)' : ''));
        var tmp10_safe_receiver = denied(item);
        var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.r53_1;
        var tmp_5;
        if (tmp11_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_5 = emptySet();
        } else {
          tmp_5 = tmp11_elvis_lhs;
        }
        return this.rgp(tmp, true, tmp_1, tmp_3, tmp_4, tmp_5);
      }
      toString() {
        return 'MessageData(message=' + this.fgp_1 + ', clientMessage=' + this.ggp_1 + ', created=' + this.hgp_1.toString() + ', sender=' + this.igp_1.toString() + ', type=' + toString(this.jgp_1) + ', readBy=' + toString(this.kgp_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.fgp_1);
        result = imul(result, 31) + getBooleanHashCode(this.ggp_1) | 0;
        result = imul(result, 31) + this.hgp_1.hashCode() | 0;
        result = imul(result, 31) + this.igp_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.jgp_1) | 0;
        result = imul(result, 31) + hashCode(this.kgp_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MessageData()))
          return false;
        if (!(this.fgp_1 === other.fgp_1))
          return false;
        if (!(this.ggp_1 === other.ggp_1))
          return false;
        if (!this.hgp_1.equals(other.hgp_1))
          return false;
        if (!this.igp_1.equals(other.igp_1))
          return false;
        if (!equals(this.jgp_1, other.jgp_1))
          return false;
        if (!equals(this.kgp_1, other.kgp_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MessageData');
    MessageDataClass = $;
  }
  return MessageDataClass;
}
function hasConcernCard(_this__u8e3s4, history) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(history, Collection())) {
      tmp = history.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = history.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      // Inline function 'kotlin.let' call
      var it = element.d8w();
      var tmp_0;
      if (!(it instanceof RequestComplete())) {
        tmp_0 = !(it instanceof Accept());
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
//region block: exports
export {
  ManualState as ManualStatewy76bep9f2j,
  ConcernCardInfo as ConcernCardInfo27c6vqv7qq44u,
  MessageData as MessageDatalcsuuwceag9q,
  hasConcernCard as hasConcernCard3nodxgigqanyg,
  Type_Incident_getInstance as Type_Incident_getInstance3i10g3y530893,
  Type_LineItem_getInstance as Type_LineItem_getInstanceq184uyry7c2,
};
//endregion

//# sourceMappingURL=ConcernCardInfo.mjs.map
